/////////////////////////////////////////////////////////////////////////////
// Utility functions for safe encoding and decoding of URI components
/////////////////////////////////////////////////////////////////////////////

import { showToast } from "../components/Toasts";

export const PRODUCT_TYPES = ["Unknown", "Actor", "Sensor", "Button", "Gateway", "Other", "DecentralActor"]; // no itx
export const PROGRAMMABLE_TYPES = ["Verified", "Potential", "No"];
export const PRODUCT_PRIORITY_TYPES = ["Unset", "0", "1"];
export const DEV_ADDRESS_TYPES = ["0", "1", "PhysicalAddressWithoutApp", "Unset"];
export const SPECIAL_USAGE_TYPES = [
  "General",
  "Visualization/Input",
  "IPInterface",
  "IPGateway",
  "PowerSupply",
  "Unset",
];
export const BOOLEAN_TYPES = ["true", "false"];

export const spinner = "las la-spinner la-spin"; // no itx

export function safeDecodeURIComponent(str: string) {
  try {
    return decodeURIComponent(str);
  } catch {
    return str; // in case it's not a valid URI component
  }
}

export function cleanDecode(str: string): string {
  let decoded = str;
  let prev: string;

  // if (str.length === 0) return str.toString();

  const hasEscapes = (s: string) => /%[0-9A-Fa-f]{2}/.test(s);

  // Keep decoding only while there are still %xx sequences
  while (hasEscapes(decoded)) {
    prev = decoded;
    try {
      decoded = decodeURIComponent(prev);
    } catch {
      // If malformed URI, just stop
      break;
    }
    if (decoded === prev) break;
  }

  // Handle extra wrapping double quotes ""..."" (even multiple layers)
  while (decoded.startsWith('""') && decoded.endsWith('""')) {
    decoded = decoded.slice(2, -2);
  }

  // Handle single quotes or single layer of quotes
  if ((decoded.startsWith('"') && decoded.endsWith('"')) || (decoded.startsWith("'") && decoded.endsWith("'"))) {
    decoded = decoded.slice(1, -1);
  }

  return decoded;
}

export function cleanEncode(str: string | undefined) {
  if (!str) return "";
  return encodeURIComponent(cleanDecode(str));
}

export function isEncoded(str: any) {
  try {
    // Decode and re-encode
    return str !== decodeURIComponent(str) && encodeURIComponent(decodeURIComponent(str)) === str;
  } catch (e) {
    // If decodeURIComponent throws, it's not valid encoding
    return false;
  }
}

export function safeJSONDecode(str: string) {
  let decoded = cleanDecode(str);

  // Parse JSON safely
  try {
    return JSON.parse(decoded);
  } catch (e) {
    console.error("Invalid JSON:", decoded);
    return null;
  }
}
/////////////////////////////////////////////////////////////////////////////

export const lowerFirst = (str) => {
  if (!str) return "";
  return str.charAt(0).toLowerCase() + str.slice(1);
};

// helper: compare versions like "3.4.1" vs "3.10"
export function compareVersions(v1, v2) {
  const parts1 = v1.split(".").map(Number);
  const parts2 = v2.split(".").map(Number);

  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const num1 = parts1[i] || 0;
    const num2 = parts2[i] || 0;
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }
  return 0; // equal
}

// Toast helper functions
export function showPersistentToast(text: string, title?: string) {
  showToast({
    title: title,
    text: text,
    keepVisible: true,
  });
}

export function downloadFile(blob: any, filename: string, fileext: string) {
  if (blob) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.${fileext}`;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}
